<template>
  <div class="col-md-6 m-auto remove-suppliers-instruction">
      <p v-if="selectedSuppliers.length==0">{{$t("supplier.selectSuppliers")}}</p>
      <p v-else>{{$t("supplier.selectedSuppliers", {count: selectedSuppliers.length})}}</p>
      <button :disabled="selectedSuppliers.length==0" @click="$emit('remove')" class="btn btn-success">{{$t("supplier.removeSuppliers")}}</button>
  </div>
</template>

<script>
export default {
  props: ["selectedSuppliers"]
}
</script>

<style scoped>
.remove-suppliers-instruction > p{
  font-size: 25px;
}
.remove-suppliers-instruction > button{
  min-width: 200px;
}

</style>